"use client";

import Link from "next/link";
import LazyImage from "src/lib/components/salify-next-layout/default/components/LazyImage";
import { ContentWrapper, FeatureImgBox, ImgBox, StyledCard } from "./default/styles";
import {
  H2,
  Paragraph,
  Span,
} from "src/lib/components/salify-next-layout/default/components/Typography";
import Box from "@mui/material/Box";
import { FlexBox } from "src/lib/components/salify-next-layout/default/components/flex-box";
import { calculateDiscount, formatMoney, toAssetImages } from "src/lib/utils";
import Rating from "@mui/material/Rating";
import ProductViewDialog from "src/lib/components/salify-next-layout/default/components/products-view/product-view-dialog";
import useProduct from "src/lib/components/salify-next-layout/default/components/product-cards/use-product";
import HoverActions from "src/lib/components/product-item/default/hover-action";
import DiscountChip from "src/lib/components/salify-next-layout/default/components/product-cards/discount-chip";

// ============================================================
const ProductItem = (props: any) => {
  const { isFavorite, openModal, cartItem, toggleDialog, toggleFavorite, handleCartAmountChange } =
    useProduct(props.slugName);
  const StyledWrapper = props.isFeature ? FeatureImgBox : ImgBox;
  return (
    <StyledCard sx={props.sx}>
      {/* <ImgBox id="imgBox" bgColor={props.itemBg}> */}
      <StyledWrapper id="imgBox">
        {props.discount > 0 && <DiscountChip discount={props.discount} />}
        <Link href={`/product/${props.slugName}`}>
          <LazyImage
            alt={props.name}
            width={550}
            height={550}
            src={toAssetImages(props.imageUrl)}
            style={{
              height: 190,
              objectFit: "contain",
            }}
          />
        </Link>

        <HoverActions
          isFavorite={isFavorite}
          toggleView={toggleDialog}
          toggleFavorite={toggleFavorite}
          handleAddToCart={() =>
            handleCartAmountChange({
              product: props,
              quantity: 1,
            })
          }
        />
      </StyledWrapper>

      <ProductViewDialog openDialog={openModal} handleCloseDialog={toggleDialog} product={props} />

      <ContentWrapper>
        <Link href={`/product/${props.slugName}`} className="title">
          <H2 mb={1} title={props.name} fontSize={14} fontWeight={600} color="text.secondary">
            {props.name}
          </H2>
        </Link>

        <Span color={props.stockMax === 0 ? "red" : "green"}>{`${
          props.stockMax === 0 ? "Hết" : "Còn"
        } hàng`}</Span>
        <FlexBox gap={1} alignItems="center">
          <Rating size="small" value={Math.round(props.rating) || 5} color="warn" readOnly />
          <Span>{props.rating || 5}</Span>
          <Span color="grey.600">({props.feedback || 1} đánh giá)</Span>
        </FlexBox>

        <FlexBox alignItems="center" gap={1} mt={0.5}>
          <Paragraph fontWeight={600} color="primary.main">
            {formatMoney(props.salePrice)}
          </Paragraph>

          {!props.discount ? (
            <Box component="del" fontWeight={600} color="grey.600">
              {formatMoney(calculateDiscount(Number(props.salePrice), Number(props.discount)))}
            </Box>
          ) : null}
        </FlexBox>
      </ContentWrapper>
    </StyledCard>
  );
};

export default ProductItem;
